import React, { useEffect } from "react";
import styled from "styled-components";


const Button = styled.a`
    background: linear-gradient(90.07deg, #3999F9 29.06%, #4A7DFF 96.96%);
    padding: 12px 16px;
    border-radius: ${props => props.rounded ? '10000px': '8px'};
    font-size: 14px;
    color: #fff;
`;

export default function BlueButton({children, rounded, href, style}){
    return (
      <>
        <Button onClick={() => {
            window.analytics.track('download_button_pressed', {
              from: 'group-page',
              type: 'mobile'
            }) 
          }} href={href} rounded={rounded} style={style}>{children}</Button>  
      </>
    );
  };